export default "__VITE_ASSET__sdzp5YvF__"